
import { get } from "../../axios/index"


export const articleRecordPage = (p) => get("/chat/articleRecordPage", p)
